var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row user-info"},[_c('p',{staticClass:"col-md-3 label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticClass:"col-md-9 info"},[_vm._v(_vm._s(_vm.info ? _vm.info : "Não informado"))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7ff9056","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/profile/p-user-info.vue
// module id = 251
// module chunks = 0